import React from 'react';
import { commonStyles } from '../../styles/common';
import { UserCheck, FileCheck, Target } from 'lucide-react';
import { Link } from 'react-router-dom';

const Expertise = () => {
  return (
    <section className={`${commonStyles.section} bg-gray-50`}>
      <div className={commonStyles.container}>
        <h2 className={commonStyles.heading.primary}>Pourquoi choisir notre expertise ?</h2>
        
        <div className="grid md:grid-cols-3 gap-8 mt-8">
          <div className="bg-white p-6 rounded-lg shadow-md">
            <UserCheck className="w-12 h-12 text-blue-600 mb-4" />
            <h3 className="text-xl font-semibold mb-2">Accompagnement personnalisé</h3>
            <p className="text-gray-600">
              Que vous soyez un particulier ou une entreprise, nous vous guidons à chaque étape.
            </p>
          </div>
          
          <div className="bg-white p-6 rounded-lg shadow-md">
            <FileCheck className="w-12 h-12 text-blue-600 mb-4" />
            <h3 className="text-xl font-semibold mb-2">Gestion complète</h3>
            <p className="text-gray-600">
              Nous prenons en charge toutes les formalités administratives et techniques.
            </p>
          </div>
          
          <div className="bg-white p-6 rounded-lg shadow-md">
            <Target className="w-12 h-12 text-blue-600 mb-4" />
            <h3 className="text-xl font-semibold mb-2">Projets sur mesure</h3>
            <p className="text-gray-600">
              Nous adaptons nos solutions à vos besoins pour maximiser vos économies.
            </p>
          </div>
        </div>
        
        <div className="mt-12 text-center">
          <Link
            to="/#contact"
            className="inline-flex items-center bg-orange-500 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-orange-600 transition-colors"
          >
            Contactez-nous
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Expertise;